<template>
  <div class="station ">
    <el-row class="station-map">
      <el-col :span="24">
        <!-- 地图 -->
        <div class="map" id='readmeMap'></div>
      </el-col>
    </el-row>
    <div class="container w1400">
      <el-table border style="width: 100%" :data="withData" ref="multipleTable">
        <el-table-column prop="ab003" label="名称"/>
        <el-table-column prop="ab004" label="位置"/>
        <el-table-column prop="ab005" label="数量"/>
        <el-table-column prop="ab006" label="GPS坐标"/>
        <el-table-column prop="ab007" label="状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.ab007==1?'success':'danger'">{{ scope.row.ab007 == 1 ? '正常' : '拆除' }}</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div class="el-pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                       :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="count">
        </el-pagination>
      </div>
    </div>
    <MapWay :drawer.sync='drawer' :destination='itemClick'></MapWay>
  </div>
</template>

<script>
import Gmap from "../../public/Gmap";
import MapWay from "../common/mapWay.vue"
export default {
  mixins:[Gmap],
  components:{
    MapWay,
  },
  data() {
    return {
      //路线弹窗
      drawer:false,
      itemClick:[],
      //map
      map: '',
      markers: [],
      withData: [],
      count: 0,
      currentPage: 1, //当前页数
      pageSize: 10, //当前每页显示多少,
    }
  },
  mounted() {
    this.initMap();
    (async () => {
      await this.getWith();
      let data = await this.getAll();
      data.forEach((ele, i) => {
        ele.ab006 = ele.ab006.split(',')
        let respone = this.initMarker(ele, i);
        this.initMapInfo(respone, ele);
      })

    })();
  },
  methods: {
    initMarker(postion, ind) {
      // 创建一个 Icon
      let icon = new AMap.Icon({
        size: new AMap.Size(24, 30),
        // 图标的取图地址
        image: require("../../assets/time.png"),
        // 图标所用图片大小
        imageSize: new AMap.Size(24, 30),
      });
      let markerContent = `<div style='position:relative;'>
                                  <img src='http://file.sywlfz.com/sylink/Images/rechargeStation.png' style='width:24px;height:30px;' />
                                  <span style='color:#a52a2a;position:absolute;left:10px;top:-15px;'>${ind}</span>
                            </div>`;
      //自定义marker
      let marker = new AMap.Marker({
        map: this.map,
        position: postion.ab006,
        icon: icon,
        // content:markerContent,
        // 设置了 icon 以后，设置 icon 的偏移量，以 icon 的 [center bottom] 为原点
        offset: new AMap.Pixel(-13, -30),
        // content:markerContent
      });
      this.markers.push(marker);
      //添加maerkers 到地图
      this.map.add([marker]);
      return marker;
    },
    initMapInfo(marker, info) {
      //实例化信息窗体
      let infoWindow = new AMap.InfoWindow({
        isCustom: true, //使用自定义窗体
        content: createInfoWindow(info),
        offset: new AMap.Pixel(16, -45)
      });
      //鼠标点击marker弹出自定义的信息窗体
      AMap.event.addListener(marker, 'mouseover', () => {
        infoWindow.open(this.map, marker.getPosition());
      });
      AMap.event.addListener(marker, 'click', (res) => {
        this.itemClick = info.ab006;
        this.drawer = true;
        // infoWindow.open(this.map, marker.getPosition());
      });
      AMap.event.addListener(marker, 'mouseout', () => {
        this.map.clearInfoWindow();
      });

      //构建自定义信息窗体
      function createInfoWindow(content) {
        let href;
        if (Array.isArray(content.tg011) && content.tg011.length == 2) {
          href = `https://gaode.com/regeo?lng=${content.tg011[0]}&lat=${content.tg011[1]}&name=&adcode=`;
        } else {
          href = "https://gaode.com/regeo?lng=110.79&lat=32.65&name=&adcode=";
        }
        let info = document.createElement("div");
        info.style.backgroundColor = "#F8F8F8";
        info.style.width = '318px';
        info.style.borderRadius = '0 0 4px 4px';
        info.style.marginBottom = '-25px';
        //init title
        info.innerHTML =
          `
                    <div class="carinfo" style="display: flex;flex-wrap: nowrap;align-items: center;padding: 10px 0 7px 8px;">
                        <div style='font-size: 14px; color: #666;height:83px display: flex;flex-direction: column;align-content: space-between;'>
                            <div style='margin-bottom: 8px;'>名称:<span style="font-weight: 700">${content.ab003}</span></div>
                            <div style='margin-bottom: 8px;'>位置:${content.ab004}</div>
                            <div style='margin-bottom: 8px;'>数量:${content.ab005}</div>
                            <div style='margin-bottom: 8px;'>状态:<span style="font-weight: 700">${content.ab007 == 1 ? '正常' : '故障'}</span></div>
                             <a href="${href}" target="_blank">点击此处导航(或者点击小图标)</a>
                        </div>
                    </div>`;

        return info;
      }
    },
    getWith() {
      return new Promise((resolve, reject) => {
        this.$axios.post("/api/tempPoint/list/", {
          skip: this.currentPage * this.pageSize - this.pageSize,
          pageSize: this.pageSize,
        }).then(res => {
          if (res.data.code != 200)
            return this.$message({
              type: 'error',
              message: '请求出错'
            })
          else
            this.withData = res.data.data,
              this.count = res.data.count;
          resolve(res.data.data)
        })
      })
    },
    getAll() {
      return new Promise((resolve, reject) => {
        this.$axios.post("/api/tempPoint/list/", {
          skip: 0,
          pageSize: this.count,
        }).then(res => {
          resolve(res.data.data)
        })
      })
    },
    handleSizeChange(e) {
      this.pageSize = e
      this.getWith(this.type)
    },
    handleCurrentChange(e) {
      this.currentPage = e
      this.getWith(this.type)
    },
  }
}
</script>

<style scoped>
.station {
  width: 100%;
  color: #333333;
}

.map {
  width: 100%;
  height: 77.1rem;
}

.station-title {
  box-sizing: border-box;
  height: 7rem;
  line-height: 7rem;
  padding-left: 2.7rem;
  background-color: #F6F5F5;
}

.container {
  overflow: hidden;
  padding: 2rem 7.4rem 0;
  background-color: #F6F5F5;
}

.handle-box {
  margin: 4.3rem auto;
  display: flex;
  justify-content: space-between;

}

.pagination {
  display: flex;
  justify-content: center;
}

.el-pagination {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/page/station.vue